import React, {useEffect, useState} from 'react';
import './ReligiousTimesStyle.scss';
import sunIcon from '../../../assets/icons/sun.svg';
import IranSanse from "../../Typography/IranSanse.tsx";
import axios from "axios";
import {ReligiousTime} from "../../../Entities/ReligiousTime.ts";



function ReligiousTimes() {
    const [religiousInfo,setReligiousInfo] = useState(new ReligiousTime())
    useEffect(() => {
        axios.get('https://prayer.aviny.com/api/prayertimes/1164').then((res) => {
            console.log(res.data);
           setReligiousInfo(res.data)
        })
    },[])
    return (<div className='ReligiousTimes'>
            <div className='ReligiousTimes-section'>
                <div className='ReligiousTime-header d-flex justify-content-start'>
                    <img style={{marginLeft: 10, marginTop: 5}} src={sunIcon} alt=""/>
                    <div style={{marginLeft: 10, marginTop: 7}}>
                        <IranSanse>اوقات شرعی حرم({religiousInfo.CityName})</IranSanse>
                    </div>
                </div>

                <div className='ReligiousTime-Today'>
                    <div className='boxRespnsiveInBigSize'>
                        <div className='ReligiousTime-box border-left'>
                            <span className='pd-left'>
                                اذان صبح
                            </span>
                            <span className='pd-left'>
                                {religiousInfo.Imsaak}
                            </span>
                        </div>
                        <div className='ReligiousTime-box border-left'>
                            <span className='pd-left'>
                                طلوع
                            </span>
                            <span className='pd-left'>
                                {religiousInfo.Sunrise}
                            </span>
                        </div>
                    </div>
                    <div className='boxRespnsiveInBigSize'>
                        <div className='ReligiousTime-box border-left'>
                            <span className='pd-left'>
                                اذان ظهر
                            </span>
                            <span className='pd-left'>
                                {religiousInfo.Noon}
                            </span>
                        </div>
                        <div className='ReligiousTime-box border-left'>
                            <span className='pd-left'>
                                غروب
                            </span>
                            <span className='pd-left'>
                                {religiousInfo.Sunset}
                            </span>
                        </div>
                    </div>
                    <div className='boxRespnsiveInBigSize'>
                        <div className='ReligiousTime-box border-left'>
                            <span className='pd-left'>
                                اذان مغرب
                            </span>
                            <span className='pd-left'>
                                {religiousInfo.Maghreb}
                            </span>
                        </div>
                        <div className='ReligiousTime-box'>
                            <span className='pd-left'>
                                نیمه شب
                            </span>
                            <span className='pd-left'>
                                {religiousInfo.Midnight}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ReligiousTimes;